<template>
  <v-layout>
    <v-navigation-drawer
      v-model="panel.activated"
      :width="$isMobile ? '100%' : '50%'"
      right
      fixed
      :permanent="panel.activated"
      hide-overlay
      class="z-index--100">
      <div class="ma-3">
        <div class="d-flex">
          <v-btn
            dark
            fab
            x-small
            outlined
            color="primary"
            class="mr-3"
            @click="onCloseIngredientsDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <div class="subtitle-1 primary--text">
            {{ (recipe) ? recipe.name : '' }}
          </div>
          <v-spacer/>
          <span class="subtitle-1" v-if="recipe.cost">
            Total: ${{ recipe.cost | toFix2 | numberWithComma }}
          </span>
        </div>
        <div>
          <v-tabs>
            <v-tab>
              Ingredientes
            </v-tab>

            <v-tab >
              Procedimiento
            </v-tab>

            <v-tab-item v-if="recipe.subrecipe === true || recipe.status !== 'attached'">
              <Ingredients
                :recipe="recipe"
                ref="ingredients"
                @updated="recalculateRecipeCost"
              />
            </v-tab-item>

            <v-tab-item v-else>
              <IngredientsViewer
                :recipe="recipe"
                ref="ingredients"
              />
            </v-tab-item>

            <v-tab-item>
              <RecipeInstructions :recipe="recipe" ref="recipeInstructions"/>
            </v-tab-item>
          </v-tabs>
        </div>
        <div class="text-right subtitle-2 mb-2 px-2" v-if="recipe && recipe.latestUpdates && recipe.latestUpdates.length > 0">
          <v-tooltip class="style-tool" left>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="font-weight-bold"
              >
                <v-icon small>mdi-information</v-icon>
                Últimas actualizaciones
              </span>
            </template>
            <v-timeline align-top dense>
              <v-timeline-item
                small
                v-for="(item, index) in recipe.latestUpdates"
                :key="`item-${index}`"
              >
                <v-row class="pt-1">
                  <v-col cols="12">
                    <strong>{{ item.updatedAt | toDateTime }}</strong>
                    <div class="caption">
                      Por {{ item.updatedBy ? item.updatedBy.email: '' }}
                    </div>
                  </v-col>
                </v-row>
              </v-timeline-item>
            </v-timeline>
          </v-tooltip>
        </div>
        <div class="text-right caption" v-if="recipe && recipe.latestUpdates && recipe.latestUpdates.length === 0">
          Última actualización {{ recipe.updatedAt | toDateTime }} por {{ recipe.updatedBy ? recipe.updatedBy.email: '' }}
        </div>
        <div class="text-right caption" v-if="recipe && recipe.lastPropagationDate">
          Última propagación {{ recipe.lastPropagationDate | toDateTime }}
        </div>
      </div>
    </v-navigation-drawer>
  </v-layout>
</template>

<script>
import Ingredients from '@/components/tabs/Ingredients'
import RecipeInstructions from '@/components/tabs/RecipeInstructions'
import IngredientsViewer from '../tabs/IngredientsViewer.vue'

export default {
  name: 'RecipeDetail',
  props: {
    ingredientDialog: {
      type: Boolean,
      default: false
    },
    recipe: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    Ingredients,
    RecipeInstructions,
    IngredientsViewer
  },
  data () {
    return {
      panel: {
        activated: false
      }
    }
  },
  watch: {
    ingredientDialog: function (val) {
      this.panel.activated = val
    }
  },
  mounted () {
    window.addEventListener('keydown', this.keyDownHandler)
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDownHandler)
  },
  methods: {
    keyDownHandler (event) {
      if (event.code === 'Escape') this.$emit('closeIngredientDialog')
    },
    onCloseIngredientsDialog () {
      this.$emit('closeIngredientDialog')
    },
    async recalculateRecipeCost () {
      const response = await this.$api.get(`/v1/recipes/${this.recipe.uuid}`)
      this.recipe.latestUpdates = response.latestUpdates
      this.recipe.updatedAt = response.updatedAt
      this.recipe.updatedBy = response.updatedBy
      this.recipe.cost = response.cost
    }
  }
}
</script>
